import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const Cookies = () => (
  <LegalPageLayout title="Cookie Policy" lastUpdated="August 2026">
    <p>
      This Cookie Policy explains how WE R GAME uses cookies and similar technologies when you visit our website.
    </p>

    <h2>What are cookies?</h2>
    <p>
      Cookies are small text files stored on your device. They help websites remember preferences, keep you signed in, and
      understand how the site is used.
    </p>

    <h2>How we use cookies</h2>
    <ul>
      <li>
        <strong>Essential:</strong> Authentication tokens, session state, and security features required for login and
        trading.
      </li>
      <li>
        <strong>Functional:</strong> Theme (light/dark), UI preferences, and referral capture.
      </li>
      <li>
        <strong>Analytics:</strong> Aggregated usage metrics to improve performance and fix errors (if enabled).
      </li>
      <li>
        <strong>Advertising:</strong> Google AdSense may set cookies to serve ads on Free details and Blog pages, and
        to limit how often you see the same ad. You can opt out of personalized ads at{' '}
        <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">
          Google Ads Settings
        </a>
        .
      </li>
    </ul>

    <h2>Third parties</h2>
    <p>
      We may use third-party services (e.g. Google Sign-In, wallet providers, analytics) that set their own cookies
      subject to their policies. Connecting a wallet interacts with your browser extension or wallet app, not cookies
      we control.
    </p>

    <h2>Your choices</h2>
    <p>
      You can block or delete cookies in your browser settings. Blocking essential cookies may prevent login or market
      features from working correctly.
    </p>

    <h2>Updates</h2>
    <p>
      We may update this policy when our practices change. The &quot;Last updated&quot; date at the top reflects the
      latest revision.
    </p>
  </LegalPageLayout>
);

export default Cookies;
